import * as React from "react"
import { bindActionCreators, Dispatch } from "redux"
import { connect } from "react-redux"
import { match, RouteComponentProps } from "react-router"
import * as _ from "lodash"
import {
	AddDemographyErrors,
	Names as AddDemographyModalNames
} from "./add-demography-modal"
import { AddWordErrors, Names as AddWordNames } from "./add-word-modal"
import { PolitiqueModalErrors, Names as PolitiqueModal } from "./politique-modal"
import LocalAuthorityDetailComponent from "./local-authority-detail-component"
import * as actionCreators from "../../../action-creators"
import DemographyDomain from "../../../domain/sfp/demography-domain"
import ApiError, { ApiErrorCode } from "../../../error/api-error"
import * as Model from "../../../model"
import DemographiesService from "../../../service/sfp/demographies-service"
import { CreateDemographyRequestBody } from "../../../service/sfp/request-body"
import { ColorsHelper } from "../../../util/colors"
import * as routes from "../../../util/routes"
import { createWord , createPolitique } from "../../../service/sfp/word-service"
import { getProfile, Profile } from "../../../domain/sfp/user-domain"
import { NotificationLevel } from "../../notification"
import * as PpisService from "../../../service/sfp/ppis-service-2"
import * as ScenariiService from "../../../service/sfp/scenarii-service"
import { ReducerState, MappedActionsProps } from "../../../reducer"

class LocalAuthorityDetail
extends React.Component<InjectedProps, State> {
	private abortController: AbortController = new AbortController()
	private currentYear: number

	constructor(props: Readonly<InjectedProps>) {
		super(props)

		this.currentYear = (new Date()).getFullYear()
		
		const localAuthority = this.getLocalAuthority(props)

		this.state = {
			addDemographyErrors: {},
			addWordErrors: {},
			PolitiqueErrors:{},
			addingDemography: false,
			addingWord: false,
			demographyData: this.getDemographyData(props.currentLocalAuthority),
			loadingPpi: false,
			loadingScenarii: false,
			localAuthority,
			ppi: null,
			ppiLoaded: false,
			scenarii: [],
			scenariiLoaded: false,
			showAddDemographyModal: false,
			showAddWord: false,
			showViewDemographiesModal: false,
			showViewGlossary: false,
			showViewPolitique: false,
			PolitiqueChanges:false,
		}
	}

	componentDidMount() {
		if (this.state.scenariiLoaded && this.state.ppiLoaded) return
		this.initData(this.props)
	}

	componentWillReceiveProps(props: Readonly<InjectedProps>) {
		if ((this.state.scenariiLoaded && this.state.ppiLoaded) || this.state.loadingPpi || this.state.loadingScenarii) return
		this.initData(props)
	}

	componentWillUnmount() {
		this.abortController.abort()
	}

	render() {
		const consulted = getProfile(this.props.currentUser) === Profile.LocalAuthorityConsultant
		return (
			<LocalAuthorityDetailComponent
			addDemographyErrors={this.state.addDemographyErrors}
			addWordErrors={this.state.addWordErrors}
			PolitiqueErrors={this.state.PolitiqueErrors}
			addingDemography={this.state.addingDemography}
			addingWord={this.state.addingWord}
			consulted={consulted}
			currentYear={this.currentYear}
			demographyData={this.state.demographyData}
			loadingLoans={this.props.loadingCurrentLocalAuthorityLoans}
			loadingLocalAuthority={this.props.loadingCurrentLocalAuthority}
			loadingPpi={this.state.loadingPpi}
			loadingScenarii={this.state.loadingScenarii}
			loadingServices={this.props.loadingCurrentLocalAuthorityServices}
			loans={this.props.currentLocalAuthorityLoans}
			localAuthority={this.state.localAuthority}
			ppi={this.state.ppi}
			scenarii={this.state.scenarii}
			services={this.props.currentLocalAuthorityServices}
			onClickAddDemography={e => { this.setState({ showAddDemographyModal: true }) }}
			onClickAddDemographyModalCloseButton={() => { this.setState({ showAddDemographyModal: false }) }}
			onClickAddDemographyModalFooterButton={() => { this.handleClickAddDemographyFooterButton() }}
			onClickAddWord={e => { this.setState({ showAddWord: true })}}
			onClickAddWordCloseButton={() => { this.setState({ showAddWord: false })}}
			onClickAddWordFooterButton={() => { this.setState({ showAddWord: false })}}
			onClickViewDemographies={e => { this.setState({ showViewDemographiesModal: true }) }}
			onClickViewDemographyModalCloseButton={() => { this.setState({ showViewDemographiesModal: false }) }}
			onClickViewDemographyModalFooterButton={() => { this.setState({ showViewDemographiesModal: false }) }}
			onClickViewPolitique={e => this.setState({showViewPolitique: true})}
			onClickPolitiqueModalButton={() => { this.setState({ showViewPolitique: false })}}
			onClickPolitiqueModalFooterButton={() => { this.setState({ showViewPolitique: false })}}
			onClickViewPolitiqueClose = {e => this.setState({showViewPolitique: false})}
			onClickViewGlossary={e => { this.setState({ showViewGlossary: true }) }}
			onClickPolitiqueChanges={e => { this.setState({ PolitiqueChanges: true }) }}
			onClickViewGlossaryCloseButton={() => { this.setState({ showViewGlossary: false })}}
			onClickViewApprocheCloseButton={() => { this.setState({ PolitiqueChanges: false })}}
			onClickViewGlossaryFooterButton={() => { this.setState({ showViewGlossary: false })}}
			onClickViewApprocheFooterButton={() => { this.setState({ PolitiqueChanges: false })}}
			onSubmitAddDemographyModal={e => { this.handleSubmitAddDemography(e) }}
			onSubmitAddWord={e => { this.handleSubmitAddWord(e) }}
			onSubmitPolitiqueModal={e => { this.handleSubmitPolitique(e) }}
			onSubmitEditWord={e => { this.handleSubmitEditWord(e) }}
			showAddDemographyModal={this.state.showAddDemographyModal}
			showAddWord={this.state.showAddWord}
			showViewDemographiesModal={this.state.showViewDemographiesModal}
			PolitiqueChanges={this.state.PolitiqueChanges}
			showViewGlossary={this.state.showViewGlossary}
			showViewPolitique={this.state.showViewPolitique} />
		)
	}

	private getDemographyData(localAuthority: Model.LocalAuthority): Chart.ChartData {

		const years = _.rangeRight(this.currentYear, this.currentYear - 8)
		const data  = { labels: years.map(year => year.toString()) } as Chart.ChartData

		if (localAuthority) {
			const backgroundColor = ColorsHelper.getPastelColor(25, 0.3)
			const borderColor     = ColorsHelper.getPastelColor(25)
			const demographies    = DemographyDomain.getDemographies(localAuthority.demographies, years)
			const dataset         = {
				backgroundColor,
				borderColor,
				data: demographies.map(demography => demography ? demography.population : null),
				fill: false
			} as Chart.ChartDataSets
			data.datasets = [dataset]
		}

		return data
	}

	private getLocalAuthority(props: Readonly<InjectedProps>): Model.LocalAuthority {
		if (props.match && routes.COLLECTIVITE === props.match.path)
			return this.props.location.state ? this.props.location.state.la :props.currentLocalAuthority 
	}

	private handleClickAddDemographyFooterButton() {
		this.setState({ showAddDemographyModal: false })
	}

	private handleSubmitAddDemography(event: React.SyntheticEvent<Element>) {
		event.preventDefault()
		const form       = event.target as HTMLFormElement
		const formData   = new FormData(form)
		const population = parseInt(formData.get(AddDemographyModalNames.POPULATION).toString())
		const year       = parseInt(formData.get(AddDemographyModalNames.YEAR).toString())
		const demography = { population, year } as CreateDemographyRequestBody

		this.setState({ addingDemography: true })

		DemographiesService.createDemography(
			this.state.localAuthority, demography, this.abortController.signal)
		.then(demography => {
			this.resolveAddDemography(this.state.localAuthority, demography);
		})
		.catch(reason => { this.rejectAddDemography(reason) })
	}

	private handleSubmitAddWord(event: React.SyntheticEvent<Element>) {
		event.preventDefault()
		const form = event.target as HTMLFormElement
		const formData = new FormData(form)
		const term = formData.get(AddWordNames.TERM).toString()
		const definition = formData.get(AddWordNames.DEFINITION).toString()
		const word = { term, definition } as Model.Word

		this.setState({ addingWord: true })

		createWord(this.state.localAuthority, word)
		.then(word => {
			this.resolveAddWord(this.state.localAuthority, word);
		})
		.catch(reason => { this.rejectAddWord(reason) })
	}

	private handleSubmitPolitique(event: React.SyntheticEvent<Element>) {
		event.preventDefault()
		const form = event.target as HTMLFormElement
		const formData = new FormData(form)
		const Politique = formData.get(PolitiqueModal.POLITIQUE).toString()
		const politicalApproach = { Politique } as Model.Word

		this.setState({ addingWord: true })

		createPolitique(this.state.localAuthority, politicalApproach)
		.then(politicalApproach => {
			this.resolvePolitique(this.state.localAuthority, politicalApproach);
		})
		.catch(reason => { this.rejectPolitique(reason) })
	}

	

	private handleSubmitEditWord(event: React.SyntheticEvent<Element>) {
		event.preventDefault()
		const form       = event.target as HTMLFormElement
		const formData   = new FormData(form)
		const term       = formData.get(AddWordNames.TERM).toString()
		const definition = formData.get(AddWordNames.DEFINITION).toString()
		const word       = { term, definition } as Model.Word
	}

	private initData(props: Readonly<InjectedProps>): void {
		const localAuthority = this.getLocalAuthority(props)
		
		if (localAuthority) {
			const demographyData = this.getDemographyData(localAuthority)
			this.setState({ demographyData, localAuthority }, () => {
				this.loadScenariiIfNeeded(localAuthority)
				this.loadPpiIfNeeded(localAuthority)
			})
		}
	}

	private loadPpi(localAuthority: Model.LocalAuthority): void {
		PpisService.findPpi(localAuthority, this.abortController.signal)
		.then(ppi => this.setState({
			loadingPpi: false,
			ppi,
			ppiLoaded: true
		}))
		.catch(error => {
			this.setState({ loadingPpi: false, ppiLoaded: true }, () => {
				if (error instanceof DOMException && error.code === 20) return

				this.props.actions.notify(
					NotificationLevel.Danger,
					`Impossible d'obtenir le PPI de la commune ${localAuthority.name}`,
					error)
			})
		})
	}

	private loadPpiIfNeeded(localAuthority: Model.LocalAuthority): void {
		// si le PPI est déjà en cours de téléchargement ou a déjà eté chargé
		// arrêter le traitement
		if (this.state.loadingPpi || this.state.ppiLoaded) return

		this.setState({ loadingPpi: true }, () => this.loadPpi(localAuthority))
	}

	private loadScenarii(localAuthority: Model.LocalAuthority): void {
		ScenariiService.findScenarii(localAuthority, this.abortController.signal)
		.then(scenarii => this.setState({
			loadingScenarii: false,
			scenarii,
			scenariiLoaded: true
		}))
		.catch(error => {
			this.setState({ loadingScenarii: false, scenariiLoaded: true }, () => {
				if (error instanceof DOMException && error.code === 20) return

				this.props.actions.notify(
					NotificationLevel.Danger,
					`Impossible d'obtenir les scénarios de la commune ${localAuthority.name}`,
					error)
			})
		})
	}

	private loadScenariiIfNeeded(localAuthority: Model.LocalAuthority): void {
		// si le scenario est déjà en cours de téléchargement ou a déjà eté chargé
		// arrêter le traitement
		if (this.state.loadingScenarii || this.state.scenariiLoaded) return

		this.setState({ loadingScenarii: true }, () => this.loadScenarii(localAuthority))
	}

	private rejectAddDemography(reason) {
		const newState = {
			addDemographyErrors: {}
		} as State

		if (reason instanceof ApiError) {
			const error = reason as ApiError
			switch (error.getCode()) {
				case ApiErrorCode.Conflict:
					newState.addDemographyErrors.year = "La démographie existe déjà pour cette année."
					break;
				case ApiErrorCode.NotFound:
					break;
			}
		}
		this.setState({
			...newState,
			addingDemography: false
		})
	}

	private rejectAddWord(reason) {
		const newState = {
			addWordErrors: {}
		} as State

		if (reason instanceof ApiError) {
			const error = reason as ApiError
			switch (error.getCode()) {
				case ApiErrorCode.Conflict:
					newState.addWordErrors.term = "Ce mot existe déjà."
					break;
				case ApiErrorCode.NotFound:
					break;
			}
		}
		this.setState({
			...newState,
			addingWord: false
		})
	}

	private rejectPolitique(reason) {
		const newState = {
			PolitiqueErrors: {}
		} as State

		if (reason instanceof ApiError) {
			const error = reason as ApiError
			switch (error.getCode()) {
				case ApiErrorCode.Conflict:
					newState.PolitiqueErrors.Politique = "Ce mot existe déjà."
					break;
				case ApiErrorCode.NotFound:
					break;
			}
		}
		this.setState({
			...newState,
			addingWord: false
		})
	}

	private resolveAddDemography(
		localAuthority: Model.LocalAuthority,
		demography: Model.Demography
	) {
		localAuthority.demographies.push(demography)

		this.setState({
			addingDemography      : false,
			demographyData        : this.getDemographyData(localAuthority),
			localAuthority,
			showAddDemographyModal: false
		})
	}

	private resolveAddWord(
		localAuthority: Model.LocalAuthority,
		word: Model.Word
	) {
		localAuthority.glossary.push(word)
		this.props.actions.updateCurrentLocalAuthority(localAuthority)

		this.setState({
			addingWord:  false,
			localAuthority,
			showAddWord: false
		})
	}

	private resolvePolitique(
		localAuthority: Model.LocalAuthority,
		word: Model.Word
	) {
		localAuthority.approaches.push(word)
		this.props.actions.updateCurrentLocalAuthority(localAuthority)
	
		this.setState({
			addingWord:  false,
			localAuthority,
			showViewPolitique: false
		})
	}
}



function mapDispatchToProps(dispatch: Dispatch<ReducerState>): MappedActionsProps {
	return { actions: bindActionCreators(actionCreators, dispatch) }
}

function mapStateToProps(state: ReducerState): ReducerState {
	return state
}

export default connect(mapStateToProps, mapDispatchToProps)(LocalAuthorityDetail)

export interface Props {
	currentLocalAuthority: Model.LocalAuthority
	currentLocalAuthorityServices: Model.Service[]
	currentUser: Model.User
	match: match<MatchParams>
	location:{
		state:{
         la:Model.LocalAuthority
		}
	}
}

interface State {
	addDemographyErrors: AddDemographyErrors
	addWordErrors: AddWordErrors
	PolitiqueErrors:PolitiqueModalErrors
	addingDemography: boolean
	addingWord: boolean
	demographyData: Chart.ChartData
	loadingPpi: boolean
	loadingScenarii: boolean
	localAuthority: Model.LocalAuthority
	ppi: Model.Ppi
	ppiLoaded: boolean
	scenarii: Model.Scenario[]
	scenariiLoaded: boolean
	showAddDemographyModal: boolean
	showAddWord: boolean
	showViewDemographiesModal: boolean
	showViewGlossary: boolean
	showViewPolitique: boolean
	PolitiqueChanges:boolean
}

interface MatchParams {
	slug: string
}

type InjectedProps =
MappedActionsProps &
Props &
ReducerState &
RouteComponentProps<MatchParams>



// WEBPACK FOOTER //
// ./src/component/local-authority/local-authority-detail/index.tsx